export default {
  inputLabel: {
    id: 'review_collection_photo_picker_title',
    defaultMessage: 'Upload photos',
  },
  inputDescription: {
    id: 'review_collection_photo_picker_helper',
    defaultMessage: 'jpeg, png, heic or heif of less than 10 MB',
  },
  errorGeneric: {
    id: 'review_collection_photo_picker_error_generic',
    defaultMessage: 'Something went wrong.',
  },
  errorWrongFormat: {
    id: 'review_collection_photo_picker_error_wrong_format',
    defaultMessage: 'Only .jpg, .jpeg, .png, .heic, and .heif accepted.',
  },
  errorTooManyFiles: {
    id: 'review_collection_photo_picker_error_too_many_files',
    defaultMessage: 'Upload 5 photos max.',
  },
  errorTooBig: {
    id: 'review_collection_photo_picker_error_too_big',
    defaultMessage: 'Upload a file under 10 MB.',
  },
} as const
